import React from "react";
import "./index.scss";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import EmojiSadIcon from "../../../Assests/Images/emojisad.svg";
import Snackbar from "@mui/material/Snackbar";

const CustomAlert = ({ message, type, isOpen, onClose }) => {
  const getIcon = () => {
    if (type === "success") {
      return <DoneIcon />;
    } else if (type === "warning") {
      return <InfoOutlinedIcon />;
    } else if (type === "error") {
      return (
        <img
          src={EmojiSadIcon}
          alt="logo"
          width={32}
          height={32}
          style={{ filter: "drop-shadow(0 0 2px #fff)" }}
        />
      );
    }
    return null;
  };

  const snackContent = () => (
    <div className={`alert-wrapper d-flex ${type}`}>
      <div className={`img-type ${type}`}>{getIcon()}</div>
      <div className="w-100">
        <p className={`message ${type}`}>{message}</p>
        <div>
          <CloseIcon
            onClick={() => onClose(false)}
            className="control-icon align-self-center"
          />
        </div>
      </div>
    </div>
  );

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    onClose(false);
  };

  return (
    <Snackbar
      open={isOpen}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      key="topRight"
      autoHideDuration={5000}
      onClose={handleClose}
      style={{ 
        position: "fixed", 
        top: "20px", 
        right: "20px", 
        zIndex: 99999, 
        isolation: "isolate" 
      }}
      sx={{
        '& .MuiSnackbar-root': {
          zIndex: 99999
        }
      }}
    >
      <div style={{ zIndex: 99999, position: "relative" }}>
        {snackContent()}
      </div>
    </Snackbar>
  );
};

export default CustomAlert;
